export { default } from './BottomLinkComponent';
